export default "__VITE_ASSET__CwfX9k_Z__"